import type {SingleComponentPluginFunction} from '../../types'
import type {InnerElementContext} from './types'
import {traverseForPack} from './traverse'
import {packComponentData, packInnerElementData} from './transformations/nesting'
import {packInnerElementQueries} from './transformations/queryToNamespace'

/**
 * Combined innerElement transformation for pack
 * First flattens nested data, then renames query properties to namespace properties
 */
const packInnerElement = (ctx: InnerElementContext): void => {
    packInnerElementData(ctx)
    packInnerElementQueries(ctx)
}

/**
 * Pack function that orchestrates all beautifier transformations
 * Traverses the component once and applies all transformations efficiently
 */
export const pack: SingleComponentPluginFunction = (component): void => {
    traverseForPack(component, {
        onComponent: packComponentData,
        onInnerElement: packInnerElement
    })
}
